import { Expose, Type } from "class-transformer";
import {
  IsArray,
  IsBoolean,
  IsDefined,
  IsInt,
  IsOptional,
  IsString,
  IsUrl,
} from "class-validator";

import { CDColumn, CDEntity } from "../orm";

import { Season } from "./Season";

@CDEntity("images")
export class LocationImage {
  @CDColumn()
  @IsUrl()
  @IsDefined()
  @Expose()
  public url: string = "";

  @IsInt()
  @IsDefined()
  @Expose()
  public order: number = 0;

  @IsBoolean()
  @IsDefined()
  @Expose()
  public isFirst: boolean = false;

  @IsArray()
  @IsDefined()
  @Expose()
  @Type(() => Season)
  public seasons: Season[] = [];

  @IsString()
  @IsOptional()
  @Expose()
  public headerBackgroundPositionY?: string;
}
